<template>
    <div id="app" style="height:100vh">
        <!--        顶部-->
        <div style="width: 100%;height: 60px;background: #031F88;overflow:hidden;">
            <!--   log  -->
            <div style="width: 120px;height: 38px;margin: 10px 30px;">
                <img src="https://oss.baigongbao.com/2021/02/04/Cr3y7bZDaF.png" style="width: 120px;height: 38px;">
            </div>
            <div style="display: flex;justify-content: center;align-content: center;margin-top: -42px">
                <div style="margin: 5px;">
                    <svg t="1691215958349" class="icon" viewBox="0 0 1135 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2748" width="18" height="18"><path d="M1079.730672 242.271723c-16.351297-52.324152-29.432335-104.648303-42.513373-156.972455C1027.40652 42.785895 1007.784963 10.0833 958.731071 0.272522H379.895143C350.462808 0.272522 324.300732 3.542781 294.868397 3.542781H203.301131c-52.324152 0-81.756487 22.891816-94.837525 75.215968-32.702595 104.648303-62.13493 212.566866-91.567265 317.21517-3.270259 13.081038-9.810778 19.621557-16.351298 29.432335v555.944112c9.810778 22.891816 26.162076 32.702595 45.783633 42.513373h1062.834331c16.351297-6.540519 22.891816-22.891816 26.162076-35.972854V422.135995c-29.432335-55.594411-35.972854-117.729341-55.594411-179.864272z m-994.158882 147.161677c22.891816-98.107784 42.513373-196.215569 65.405189-297.593613 6.540519-29.432335 19.621557-42.513373 52.324152-42.513373H929.298736c49.053892 0 55.594411 3.270259 65.405189 52.324152 22.891816 107.918563 49.053892 219.107385 75.215969 330.296207v9.810779h-997.429142c3.270259-19.621557 6.540519-35.972854 13.081038-52.324152z m994.158882 569.02515H56.139454V481.000665h1023.591218v477.457885z" fill="#ffffff" p-id="2749"></path><path d="M854.082768 647.783899H285.057618v134.080639h565.75489V647.783899h3.27026zM929.298736 160.515236H209.84165c-13.081038 0-19.621557 9.810778-19.621557 22.891817 0 13.081038 6.540519 19.621557 19.621557 22.891816h716.186826c13.081038-3.270259 19.621557-9.810778 19.621557-22.891816 3.270259-13.081038-6.540519-22.891816-16.351297-22.891817z m-22.891817 117.729342H232.733466c-13.081038 3.270259-19.621557 13.081038-16.351297 26.162075 0 13.081038 13.081038 19.621557 29.432335 19.621557h657.322156c13.081038-3.270259 19.621557-9.810778 19.621557-22.891816s-6.540519-19.621557-16.351298-22.891816z" fill="#ffffff" p-id="2750"></path></svg>
                </div>
                <div style="font-size: 18px;color: #FFFFFF;font-weight: bold;">草稿箱</div>
            </div>
        </div>
        <div style="height:calc(100% - 60px);overflow:hidden;">
            <div style="width: 1920px;background: #E3E4E7;display: flex;height: 100%;overflow: hidden;justify-content: space-around;margin: 0 auto;">
                <!--  左侧-->
                <div style="overflow: hidden;height: 100%;">
                    <div  style="width: 250px;height: 100%;background: #FFFFFF;float: left;padding-left: 2px;overflow: hidden">
                        <div style="width: 100%;text-align: center;height: 40px;">
                            <div style="padding-top: 15px;">
                                <el-button @click="addnewarticle" class="spanbutton">发布新文章</el-button>
                            </div>
                        </div>
                        <div class="roll" style="margin-top: 20px;">
                            <div  style="width: 100%;height:80px;" v-for="(item,index) in DraftList" :key="index">
                                <div style="padding: 26px 8px;float: left;">
                                    <div style="width: 8px;height: 8px;background: #2970FF;border-radius: 50%;"></div>
                                </div>
                                <div style="float: left;height: 40px;margin: 15px 0 0 5px;">
                                    <div @click="edit(index)" class="op sc hand" style="float: left;overflow: hidden;">
                                        <div style="height: 20px;font-size: 15px;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{item.title}}</div>
                                    </div>
                                    <div @click="edit(index)" class="op sc hand" style="font-size: 12px;clear: both;float: left;">{{item.createTime}}</div>
                                    <div style="float:left;margin-left: 50px">
                                        <el-dropdown >
                                            <span class="el-dropdown-link">
                                                <i class="el-icon-more"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown" >
                                                <div @click="getdelete(item.id)"><el-dropdown-item  command="delete">删除内容</el-dropdown-item></div>
                                                <!--   <div @click="edit(index)"><el-dropdown-item  command="edit">编辑内容</el-dropdown-item></div>-->
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  中间部分 -->
                <div style="width:71%;overflow-x: hidden;overflow-y: hidden;height: 100%;">
                    <div class="avatar-uploader" style="float:left;overflow: hidden;height: 100%;">
                        <div style="width: 1300px;height: 100%;" >
                            <div style="margin:0px 9px;background: #FFFFFF;overflow:auto;height: 100%;;">
                                <div style="width:1257px;float: left;height: 100%;">
                                    <div style="height: 40px;margin:10px 20px;border: none;">
                                        <el-input style="width:1240px;height: 40px;border: none;font-size: 26px;font-weight: bold;" v-model="params.title" placeholder="请输入文章标题（不超过50个字）" maxlength="50"></el-input>
                                    </div>
                                    <!--编辑器-->
                                    <div style="margin-left: 20px;height: calc(100% - 150px);">
                                        <div style="width:1240px;height: 100%;">
                                            <Editor :style="{ border: '1px solid #999999', height: '100%' }" :tinymce_height="'100%'"  :innerDrawer = "innerDrawer = true" :value="params.content"  ref="ch"></Editor>
                                        </div>
                                    </div>
                                    <!-- 底部按钮 -->
                                    <template>
                                        <label v-if="short == true">
                                            <div @click="add_draft(1)" style="width: 130px;height: 40px;margin: 20px;float: right">
                                                <el-button type="primary" class="el-icon-position">发布新文章</el-button>
                                            </div>
                                            <div @click="add_orsave(2)" style="width: 130px;height: 40px;margin: 20px 5px;float: right">
                                                <el-button type="success" class="el-icon-edit">保存编辑内容</el-button>
                                            </div>
                                        </label>
                                        <label v-else>
                                            <div v-if="$route.params.id > 0">
                                                <div @click="add_draft(2)" style="width: 130px;height: 40px;margin: 20px 5px;float: right">
                                                    <el-button type="primary" class="el-icon-position">保存</el-button>
                                                </div>
                                            </div>
                                            <div v-else-if="$route.params.id == 0">
                                                <div @click="add_draft(1)" style="width: 130px;height: 40px;margin: 20px 5px;float: right">
                                                    <el-button type="primary" class="el-icon-position">发布文章</el-button>
                                                </div>
                                                <div @click="add_orsave(1)" style="width: 130px;height: 40px;float: right;margin-top: 20px;">
                                                    <el-button type="info" class="el-icon-bottom">保存草稿</el-button>
                                                </div>
                                            </div>
                                        </label>
<!--                                        <label v-else-if="$route.params.id ==  0">-->
<!--                                            <div  @click="" style="width: 130px;height: 40px;margin: 20px 5px;float: right">-->
<!--                                                <el-button type="primary" class="el-icon-position">保存草稿内容</el-button>-->
<!--                                            </div>-->
<!--                                        </label>-->
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  右侧部分 -->
                <div style="background: #FFFFFF;height: 100%;width: 400px;">
                    <el-button style="float:left;background: #2970FF;height: 34px;margin: 20px;" type="info" size="mini" @click="create_thumb_pic()" slot="reference">获取文章图片</el-button>
                    <el-dialog :close-on-click-modal="false"
                            title="图片封面"
                            :visible.sync="dialogShow"
                            :style="{minHeight: '100px'}"
                            center>
                       <div style="width: 100%;">
                           <div v-if="imgMsgErr.code > 0" style="height: 80px;">
                               <template >
                                   <el-alert v-if="imgMsgErr.code == 1" type="success" title="温馨提示" :closable="false">{{imgMsgErr.msg}}</el-alert>
                                   <el-alert v-if="imgMsgErr.code == 2" type="warning" title="温馨提示" :closable="false">{{imgMsgErr.msg}}</el-alert>
                                   <el-alert v-if="imgMsgErr.code == 3" type="error" title="温馨提示" :closable="false">{{imgMsgErr.msg}}</el-alert>
                               </template>
                           </div>
                           <div style="width: 25%;height: 150px;float: left;" v-for="(item,index) in cover_imgs" :key="index" @click="change_border(index)" :class="{'active':index==coverIndex}">
                               <img style="width: 100%;height:100%;overflow: hidden;" :src="item+'-300x150'">
                           </div>
                       </div>
                    </el-dialog>

                    <div style="height: 200px;">
                        <div style="width: 156px;height: 106px;margin-left: 7px;">
                            <el-upload style="margin-left: 12px;width: 156px;height: 106px;"  drag action="" :http-request="upload_img2" :show-file-list="false" v-if="params.cover == '' ">
                                <i class="el-icon-plus" style="width: 20px;height: 20px;font-size: 20px;color: #2970FF;margin-top:40px;text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);font-weight: 400;"></i>
                                <div style="font-size: 12px;color: #666666">点击上传封面</div>
                            </el-upload>
                        </div>
                        <div style="width: 170px;height: 106px;position: relative;margin-top: -30px;margin-left: 12px" v-if="params.cover != ''">
                            <img :src="params.cover" style="width: 156px;height: 106px;border-radius: 6px;object-fit: cover;">
                            <div style="background:#ff7575;color:#FFF;text-align:center;width:15px;line-height:20px;position: absolute;left: 140px;bottom: 87px; cursor:pointer;user-select: none;" @click="removeImg2()">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%;border-top: 1px solid #BDBFC1;"></div>
                    <div style="min-height: 450px">
                        <!--   文章来源   -->
                        <div style="width: 100%;">
                            <div style="margin: 10px;">
                                <div style="height: 17px;font-size: 16px;color: #545454;float: left;margin-left: 10px;">文章来源</div>
                                <div style="float: left;margin-left: 10px;margin-top: 2px;">
                                    <template>
                                        <el-radio v-model="params.form" :label="1" @change="clearInput">原创文章</el-radio>
                                        <el-radio v-model="params.form" :label="2">转载推荐</el-radio>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <!--  原文链接 -->
                        <div style="width: 100%;clear: both">
                            <div style="height: 38px;padding: 15px 20px" >
                                <el-input v-model="params.reprintedAddress" placeholder="请填写原文链接" :disabled="params.form === 1"></el-input>
                            </div>
                        </div>
                        <!--  文章话题   -->
                        <div style="width: 100%;display: flex;margin: 10px 20px">
                            <div style="width: 20%;margin: 10px  0 20px 0;font-size: 16px;" >文章话题</div>
                            <div style="width: 75%;">
                                <el-select style="width: 240px;" v-model="params.topicId" label="请选择话题" :value="params.topicId">
                                    <el-option v-for="item in TopicList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <!--  权限限制   -->
                        <div style="width: 100%;display: flex;margin: 10px 20px">
                            <div style="width: 20%;margin: 10px  0 20px 0;font-size: 16px;" >权限设置</div>
                            <div style="width: 70%;margin: 5px;">
                                <template >
                                    <el-radio-group v-model="params.auth">
                                        <el-radio :label="1" >仅自己可见</el-radio>
                                        <el-radio :label="2" >仅好友可见</el-radio>
                                        <el-radio :label="3" >仅粉丝</el-radio>
                                        <el-radio :label="4" style="margin-left: 30px;">全部可见</el-radio>
                                    </el-radio-group>
                                </template>
                            </div>
                        </div>
                        <!--  是否允许评论 -->
                        <div style="width: 100%;display: flex;margin: 10px 20px">
                            <div style="width: 30%;margin: 10px  0 20px 0;font-size: 16px;" >是否允许评论</div>
                            <div style="width: 70%;margin: 5px;">
                                <template >
                                    <el-radio style="padding-top: 10px;" v-model="params.isComment" :label="1">是</el-radio>
                                    <el-radio style="padding-top: 10px;" v-model="params.isComment" :label="2">否</el-radio>
                                </template>
                            </div>
                        </div>
                        <!--    是否转发   -->
                        <div style="float: left">
                            <p style="margin: 10px 0 0 30px ;">是否允许转发</p>
                        </div>
                        <div style="float: left;margin: 10px;">
                            <el-switch
                                v-model="params.isReprinted"
                                active-color="#13ce66"
                                inactive-color="#DCDFE6"
                                :active-value="1"
                                :inactive-value="0">
                            </el-switch>
                        </div>

                        <!--  AT -->
                        <div style="clear: both;width: 100%;margin: 10px 30px;cursor: pointer" >
                            <div @click="get_at">
                                <div style="float:left; font-size:20px;line-height:38px; margin-right:3px;"><svg t="1694054019411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4851" width="20" height="20"><path d="M514.162246 64.443731c-246.201331 0-446.51045 200.783932-446.51045 447.571618 0 246.772336 201.037712 447.539896 448.157973 447.539896 50.29857 0 99.615788-8.224312 146.523121-24.436552 18.414395-6.370081 31.060413-12.423961 31.472805-12.630668 7.194866-3.217275 12.614296-9.049097 15.213493-16.401552 2.63092-7.305383 2.155083-15.133675-1.299599-22.043039l-2.883677-5.831822c-7.131421-14.262842-24.974811-20.569478-40.156582-13.850449-0.031722 0.031722-5.8001 3.02694-20.094664 8.082072-41.075511 14.627139-84.21196 22.059412-128.235616 22.059412-210.92592 0-382.487298-171.57775-382.487298-382.487298S305.423131 129.512702 516.349051 129.512702c210.894198 0 382.455575 171.5931 382.455575 382.423853-0.887206 51.868321-13.882172 100.486622-36.606733 136.855948-20.664645 33.104979-46.939055 51.994188-72.199369 51.994188-0.317225 0-0.601704 0-0.887206 0-45.829791-0.792039-75.433016-68.586075-75.433016-172.718737l0-185.269587c0-5.53097-1.426489-9.635451-4.373611-12.550851-4.944616-4.944616-12.360516-4.817726-21.267373-4.864798l-2.472308 0.016373-9.223059-0.016373c-7.701402 0.031722-13.469779-0.063445-17.495466 3.945869-3.645017 3.613294-4.119831 9.096169-4.119831 13.469779l0 31.060413c-45.196365-36.100196-80.440054-59.474556-131.9758-60.378136-1.045819-0.016373-2.059915-0.031722-3.074012-0.031722-108.74368 0-198.470237 99.218746-200.657043 222.779899-2.155083 124.701117 84.845387 227.723491 193.969737 229.625818 1.045819 0.01535 2.059915 0.031722 3.074012 0.031722 63.293535 0 122.276904-34.087353 159.992901-92.103698 24.373107 60.251246 61.519122 91.216491 110.48637 92.071975 0.697895 0.01535 1.394766 0.01535 2.060939 0.01535 33.945113 0 66.716494-14.610766 94.924953-42.328038 47.63695-46.796816 76.066443-124.796284 76.066443-208.643947l0-2.883677C959.595154 265.227664 759.761873 64.443731 514.162246 64.443731zM646.73975 541.348422c0 92.230588-58.475809 167.282934-130.390699 167.282934s-130.390699-75.052347-130.390699-167.282934c0-92.246961 58.475809-167.298284 130.390699-167.298284S646.73975 449.102485 646.73975 541.348422z" fill="#4280dc" p-id="4852"></path></svg></div>
                                <div style="font-size: 17px;float: left;line-height:35px;">AT</div>
                            </div>
                            <div v-if="at_user_list.length > 0" style="color: #999999;font-size: 14px;float: right;margin-right: 50px;margin-top: 10px;">当前已选择:<span style="color: #2970FF">{{at_user_list.length}}</span>位</div>
                        </div>

                        <el-dialog :close-on-click-modal="false" :visible.sync="at_open" style="clear: both;height: 500px;">
                            <div style="background:  #FAFAFA;padding: 10px;clear: both;margin-left: 10px;height: 50px;">
                                <el-tag type="info" style="color:#031F88;margin:2.5px 5px;" v-for="(item,index) in at_user_list" :key="index" size="mini" closable @close="removeAt(index)"> @{{item.friendInfo.nickName}}</el-tag>
                            </div>
                            <div style="display:flex; justify-content: space-between; overflow: hidden;height: 40px;line-height: 40px;background:  #FAFAFA;padding:  0 10px; border-top:1px dashed #ccc;">
                                <div style="float: left;">您可以@以下好友</div>
                            </div>
                            <div v-for="(item,index) in all_user_list" :key="index">
                                <div style="margin-top: 5px;" @click="set_at_user(item.id,item.friendInfo.nickName,index)">
                                    <div style="width: 30px;height: 30px;float: left;margin-left: 15px;">
                                        <img :src="item.friendInfo.headIco" style="width: 30px;height: 30px;border-radius: 50%">
                                    </div>
                                    <div style="float: left;line-height: 40px;margin: 0 5px; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer">{{item.friendInfo.nickName}}</div>
                                </div>
                            </div>
                            <div style="height: 100px;"></div>
                        </el-dialog>
                    </div>
                    <div style="width: 100%;border-top: 1px solid #BDBFC1;"></div>
                    <!-- 上传附件   -->
                    <el-button style="float:left;background: #2970FF;height: 34px;margin: 20px;" type="info" size="mini" @click="set_upload_file_open" >上传文章附件</el-button>
                    <div v-if="enclosure.length > 0" style="color: #999999;font-size: 14px;float: right;margin: 30px;">当前附件:<span style="color: #2970FF">{{enclosure.length}}</span>个</div>
                    <!--传文件-->
                    <el-dialog :close-on-click-modal="false" :show-close=false :visible.sync="upload_file_open" width="398px">
                        <el-tabs v-model="file_tag_name" type="border-card">
                            <el-tab-pane label="电脑上传" name="pc" >
                                <el-upload ref="upload_enclosure" accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"  class="upload_url" style="width: 330px;" action="" drag multiple :http-request="upload_file" :show-file-list="false">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </el-upload>
                            </el-tab-pane>
                            <el-tab-pane label="手机上传" name="mobile">
                                <div style="padding:10px;color:#a6a6a6;line-height:20px;">
                                    <p>使用微信“扫一扫”打开小程序</p><P>在 百工宝小程序 中向“文件助手”发送文件</P>
                                </div>
                                <div style="text-align:center;">
                                    <img :src="upload_qrcode" style="width:150px;height:150px;">
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <div style="overflow: hidden; height:55px;line-height:20px;">
                            <div style="float:left;color:#acacac;margin-top: 18px">
                                文件数:{{enclosure.length}}
                            </div>
                            <el-button style="width: 80px; height: 34px; border-radius: 5px; margin: 10px 0 0 108px;" @click="cancelFiles">取消</el-button>
                            <el-button style="width: 80px; height: 34px; border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 20px" @click="upload_file_open = false">确定</el-button>
                        </div>
                        <div style="overflow:hidden;">
                            <div  class="video" v-for="(item,index) in enclosure" :key="index" style="width:80px;height:100px;border-radius:3px; float:left; margin:5px; background-size:100%;position:relative;" :title="item.name">
                                <div style="width:100%;height:calc(100% - 20px);background-color: rgba(0,0,0,.3);">
                                    <img :src="ossUrl+'img/file.png'" style="width:100%;height:100%;" />
                                </div>
                                <div style="height:20px;width:70px;margin: 0 5px;line-height: 20px;text-align: center;word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{item.name}}</div>
                                <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeFile(index)">
                                    <i class="el-icon-close"></i>
                                </div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
        <el-dialog title="图片转化进度" :close-on-click-modal="false" :show-close=false :visible.sync="upload_file_loading" width="398px">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="progress"></el-progress>
        </el-dialog>
    </div>
</template>

<script>
import Editor from "@/components/common/Editor.vue"
import Diy from "../form/diy";

export default {
    components: {
        Diy,
        Editor,
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    data() {
        return {
            dialogShow :false,
            thumbs:[
                "https://baigongbao.oss-cn-beijing.aliyuncs.com/img/thumbnail1.jpg",
                "https://baigongbao.oss-cn-beijing.aliyuncs.com/img/thumbnail2.jpg",
                "https://baigongbao.oss-cn-beijing.aliyuncs.com/img/thumbnail3.jpg",
                "https://baigongbao.oss-cn-beijing.aliyuncs.com/img/thumbnail4.png"
            ],

            title_list:[],
            title_index:0,

            //   附件
            upload_file_open: false,

            file_tag_name: 'pc',
            upload_qrcode:"https://baigongbao.oss-cn-beijing.aliyuncs.com/img/xcx_qrcode.jpg-80*80",
            TopicList:[],
            DraftList:[],
            cover_imgs:[],
            files:[],
            coverIndex:0,
            params:{
                cover:"",
                content:"",
                // 文章来源
                form: 1,
                //    权限
                auth: 4,
                // 是否允许评论
                isComment:1,

                topicId:"",
                title:"",
                isReprinted:0,
                operationType:'',
                reprintedAddress:'',
                enclosure:[],
            },
            enclosure:[],
            all_user_list:[],
            at_user_list:[],
            at_open:false,
            short:false,

            //图片进度
            upload_file_loading:false,
            images:[],
            totalImages: 0,
            progress:0,
            imgMsgErr:{
                code:0,
                msg:''
            },
            oss_url:[],
        }
    },
    mounted: function () {
        var that = this;
        this.id = this.$route.params.id;
        this.getTopTopicList()
        // 获取草稿箱草稿列表
        this.getArticleDraftList();
        this.getMyFriendGroupList();
        if (this.$route.params.id > 0){
            this.getArticleInfo()
        }
    },
    methods:{
        clearInput() {
            if (this.params.form === 1) {
                this.params.reprintedAddress = '';
            }
        },
        hideChild(){
            this.dialogShow = true;
        },
        // 移除好友
        removeAt(index) {
            var aindex = this.at_user_list[index].num ;
            this.all_user_list[aindex].check = false;
            this.at_user_list.splice(index,1);
        },
        get_at(){
            this.at_open = !this.at_open;
        },
        set_at_user(id,nickName,index){
            if (this.all_user_list[index].check) {
                this.all_user_list[index].check = false;
                for (var i = 0; i < this.at_user_list.length; i++) {
                    if (this.at_user_list[i].num ==index) {
                        this.at_user_list.splice(i,1);
                    }
                }
            }else{
                this.all_user_list[index].check = true;
                this.at_user_list.push(this.all_user_list[index]);
            }
        },
        // 获取好友列表
        getMyFriendGroupList(){
            this.all_user_list = [];
            this.newApi.getMyFriendGroupList({}).then(res =>{
                for (const item of res.data) {
                    for (const friends of item.friendArr) {
                        this.all_user_list.push(friends)
                    }
                }
                for (var i = 0; i < this.all_user_list.length; i++) {
                    this.all_user_list[i]['num'] = i
                }
            })
        },

        // 获取草稿箱草稿列表
        getArticleDraftList(){
            let that = this;
            that.newApi.getArticleDraftList({}).then((res)=>{
                that.DraftList = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 点击删除草稿箱的内容
        getdelete(id){
            let that = this;
            this.utils.confirm("此操作将永久删除该文章, 是否继续?", () => {
                that.newApi.deleteArticleDraft({
                    id:id
                }).then((res)=>{
                    this.utils.sus(res.data);
                    this.utils.a("/content/add/0");
                }).catch((err)=>{
                    console.log(err)
                })
            })
        },
        //生成文章封面
        create_thumb_pic() {
            var that = this;
            that.oss_url = [];
            var imgReg = /<img.*?(?:>|\/>)/gi;
            var srcReg = /src=['"]?([^'"]*)['"]?/i;
            let chil = that.$refs.ch;
            var content = chil.get_content();
            content = content.replace(/amp;/g, "");
            var arr = content.match(imgReg);
            if (arr == null) {
                that.cover_imgs = that.thumbs;
                that.dialogShow = true;
            } else {
                var imgs = [];
                for (var i = 0; i < arr.length; i++) {
                    var src = arr[i].match(srcReg);
                    imgs.push(src[1]);
                }
                //开始替换
                if (imgs.length == arr.length) {
                    that.progress = 0;
                    that.upload_file_loading = true;
                    that.totalImages = imgs.length;
                    var contains = 0;
                    for (let i = 0; i < imgs.length; i++) {
                        if (imgs[i].includes("baigongbao")) {
                            contains++;
                            that.progress = Math.floor((contains / this.totalImages) * 100);
                            that.oss_url.push(imgs[i]);
                            if(i == imgs.length - 1){
                                that.loopOperation(imgs);
                            }
                        } else {
                            that.newApi.uploadThumbImg({url: imgs[i]}).then((res) => {
                                if (res.isSuccess == 1) {
                                    if (res.data.code == 1) {
                                        contains++;
                                        that.progress = Math.floor((contains / this.totalImages) * 100);
                                        that.oss_url.push(res.data.url);
                                        content = content.replace(imgs[i], res.data.url);
                                        let chil = that.$refs.ch;
                                        chil.set_content(content);
                                    }

                                    if(i == imgs.length - 1){
                                        that.loopOperation(imgs);
                                    }
                                }
                            })
                        }
                    }

                } else {
                    that.cover_imgs = imgs;
                    that.dialogShow = true;
                }
            }
        },

        loopOperation(imgs) {
            var that = this;
            setTimeout(function (){
                if(that.oss_url.length == imgs.length){
                    that.imgMsgErr.code = 1;
                    that.imgMsgErr.msg = "所有图片转化完毕";
                }else if(that.oss_url.length > 0 && that.oss_url.length < imgs.length){
                    that.imgMsgErr.code = 2;
                    that.imgMsgErr.msg= "部分图片转化失败,请手动上传失败封面";
                }else{
                    that.imgMsgErr.code = 3;
                    that.imgMsgErr.msg= "图片提供方拒绝提供图片资源,转化失败,请手动上传封面";
                }
                that.cover_imgs = that.oss_url;
                that.dialogShow = true;
                that.upload_file_loading = false;
            },1000)
        },

        //监听选中封面样式
        change_border(index){
            this.coverIndex = index;
            this.params.cover = this.cover_imgs[index];
        },

        upload_img2:function(params){
            var file = params.file;
            var that = this;
            const isLt5M = file.size / 1024 / 1024 < 20
            if (!isLt5M) {
                that.utils.err('上传文件大小不能超过 20MB!')
                return false
            }
            that.utils.upload(file,function (url){
	            if (!url){
		            return false;
	            }
                that.params.cover = url.url;
            })
        },
        /**
         * 上传附件事件
         */
        set_upload_file_open:function(){
            this.upload_file_open = true
        },

        // 取消文件上传
        cancelFiles() {
            this.enclosure = [];
            this.upload_file_open = false;
            this.$refs['upload_enclosure'].clearFiles();
        },
        //移除附件
        removeFile:function(index){
            var that = this;
            that.enclosure.splice(index,1);
        },
        //上传附件
        upload_file:function(params){
            var that = this;
            var file = params.file;
            that.openLoading('正在上传请稍后')
            that.utils.upload(file,function(url){
                if (!url){
                    return false;
                }
                var obj = {
                    name:url.name,
                    url:url.url,
                    hash:url.hash
                };
                that.enclosure.push(obj);
            })
        },
        //  获取话题列表
        getTopTopicList(){
            var that = this;
            that.newApi.getTopTopicList({}).then((res)=>{
                that.TopicList = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        //移除封面
        removeImg2:function(){
            var that = this;
            that.utils.confirm("移除这个封面？",function(){
                that.params.cover= "";
            })
        },
        // 发布按钮
        add_draft(operationType){
            // 1 是发布 2是编辑
            var that = this;
            that.params.operationType = operationType
            if (operationType == 2){
                that.params.id = that.params.id
            }
            if(that.params.title == ""){
                this.utils.err("标题不能为空");
                return;
            }
            // 文章是2
            that.params.type = 2;
            // 图片
            that.params.images = [];
            // 视频
            that.params.videos = [];
            that.params.link = "";
            // 内容
            let chil = that.$refs.ch;
            let content = chil.get_content();
            content = content.replace(/amp;/g,"");
            that.params.content = content;
            if(that.params.content == ""){
                that.utils.err("请填写内容");
                return false;
            }
            let friends = [];
            for (const at of that.at_user_list) {
                friends.push(at.friendInfo.uuid)
            }
            that.params.AT = JSON.stringify(friends);
            // 附件
            const formattedEnclosure = this.enclosure.map(item => {
                return {
                    name: item.name,
                    url: item.url,
                    hash:item.hash
                };
            });
            this.params.enclosure = JSON.stringify(formattedEnclosure);
            // 原创转载
            this.params.form = this.params.form;
            //  原文链接
            if (that.params.form == 2){
                if(this.params.reprintedAddress == ''){
                    this.utils.err('请输入转载地址');
                    return
                }else {
                    this.params.reprintedAddress = this.params.reprintedAddress
                }
            }

            // 封面
            if(that.params.cover == ""){
                that.utils.err("请上传封面");
                return false;
            }
            // if(that.params.topicId == ""){
            //     that.utils.err("请选择一个话题");
            //     return false;
            // }
            that.openLoading('发布中....');
            that.newApi.inspirationAddOrSave(that.params).then((res)=>{
                if(res.isSuccess === 1){
                    this.utils.sus(res.data);
                    // 这里判断从编辑列表发布文章要删除那一条编辑列表得内容 所以吧id传进去
                    if (that.params.operationType == 1){
                        if (that.params.id > 0){
                            that.deleteArticleDraft(that.params.id)
                        }
                    }
                    this.utils.a("/circle/index");
                }
            }).catch((err)=>{
                console.log(err)
            })

        },
        edit(index){
            if (this.$route.params.id != 0){
                this.utils.err("当前不能编辑草稿内容!");return
            }
            this.params = this.DraftList[index];
            console.log(this.DraftList[index])
            this.enclosure = this.DraftList[index].enclosure;
            this.$refs.ch.set_content(this.params.content);
            this.short = true;
            this.editid = this.params.id
        },
        // 从草稿列表发布新文章删除列表那一篇内容
        deleteArticleDraft(id){
            let that = this;
            that.newApi.deleteArticleDraft({
                id:id
            }).then((res)=>{
                console.log(res.data)
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 保存草稿
        add_orsave(type){
            var that = this;
            if(that.params.title == ""){
                this.utils.err("标题不能为空");
                return;
            }
            if (type === 2){
                that.params.id = this.editid
            }
            // 内容
            let chil = that.$refs.ch;
            let content = chil.get_content();
            content = content.replace(/amp;/g,"");
            that.params.content = content;
            if(that.params.content == ""){
                that.utils.err("请填写内容");
                return false;
            }
            // 附件
            const formattedEnclosure = this.enclosure.map(item => {
                return {
                    name: item.name,
                    url: item.url,
                    hash:item.hash
                };
            });
            this.params.enclosure = JSON.stringify(formattedEnclosure);
            // 原创转载
            this.params.form = this.params.form;
            if (that.params.form == 2){
                if(this.params.reprintedAddress == ''){
                    this.utils.err('请输入转载地址');
                    return
                }else {
                    this.params.reprintedAddress = this.params.reprintedAddress
                }
            }
            // 封面
            if(that.params.cover == ""){
                that.utils.err("请上传封面");
                return false;
            }
            if(that.params.topic == ""){
                that.utils.err("请选择一个话题");
                return false;
            }
            that.newApi.articleDraftAddOrSave(that.params).then((res)=>{
                this.utils.sus(res.data);
                this.params.title = "";
                let chil = this.$refs.ch;
                chil.set_content("");
                this.params.content = "";
                this.params.cover = "";
                this.params.topicId = "";
                this.enclosure = [];
                this.params.form = 1;
                this.params.reprintedAddress = "";
                this.params.id = "",
                this.params.isComment = 1;
                this.params.isReprinted = 0;
                this.params.auth = 4;
                this.short = false
                this.getArticleDraftList();
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 发布新文章清空里面值
        addnewarticle(){
            this.utils.confirm("确定发布新文章？则编辑的内容会被清空", () => {
                this.params.title = "";
                let chil = this.$refs.ch;
                chil.set_content("");
                this.params.content = "";
                this.params.cover = "";
                this.params.topicId = "";
                this.enclosure = [];
                this.params.auth = 4;
                this.params.form = 1;
                this.params.reprintedAddress = "";
                this.params.isComment = 1;
                this.params.isReprinted = 0;
                this.at_user_list = [];
                this.params.id = ""
                this.short = false
            })
            this.getArticleDraftList();
        },
        // 获取文章详情
        getArticleInfo(){
            var that = this;
            that.newApi.getArticleInfo({
                id:that.$route.params.id
            }).then((res)=>{
                that.params = res.data;
                that.enclosure = res.data.enclosure;
                if (res.data.topicId == 0) {
                    that.params.topicId = ""
                }
            }).catch((err)=>{
                console.log(err)
            })
        }
    }
}
</script>

<style scoped>
/deep/ .el-menu--horizontal>.el-menu-item.is-active {
    color: #409EFF;
}
/deep/ .el-menu-item {
    font-size: 16px;
    font-weight: bold;
}
/deep/ .el-upload-dragger {
    width: 156px;
    height: 106px;
}
/*/deep/ .el-radio__inner {*/
/*    width: 16px;*/
/*    height: 16px;*/
/*}*/
/*/deep/ .el-radio__inner::after {*/
/*    width: 6px;*/
/*    height: 6px;*/
/*}*/

/deep/ .el-radio__label {
    font-size: 15px;
}
/deep/ .upload_url {
    width: 500px;
}
/deep/ .dragger-file {
    width: 300px !important;
}
/deep/ .el-radio {
    margin-right: 24px;
    float: left;
}
.active{
    box-shadow:0 0 5px 10px #409eff;
}
/deep/  .upload_url .el-upload-dragger {
    width: 330px !important;
    height: 164px !important;
}
/deep/ .el-dialog__body {
    display: flex;
    flex-direction: column;
}
.spanbutton  {
    border-top: none; /* 去除上边框 */
    border-left: none; /* 去除左边框 */
    border-right: none; /* 去除右边框 */
    border-bottom: none; /* 去除底边框 */
    font-weight: bold;
    font-size: 18px;
    color: #444444;
}
.roll {
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    height: 800px;
}
.roll::-webkit-scrollbar {
    display: none;
}
</style>
